import React, { useState, CSSProperties } from 'react';
import PaymentScreen from '../components/PaymentScreenNoScroll';
import { colors } from '../colors';
import { i18n } from '../i18n'
import { IContract, Payment } from '../models/ContractDetails';
import { signOut } from 'firebase/auth';
import { auth } from '../config2';

import ContractService from '../services/ContractService';
import { useQuery } from '@tanstack/react-query';
import { AuthenticatedUserContext } from '../providers';
import { UserContextType } from '../@types/user';
import MasterDetail from '../components/grids/MasterDetail';

const showUnits = false;

export default function ContractsScreen() {
  const { user, setUser } = React.useContext(AuthenticatedUserContext) as UserContextType;

  const { data: contracts, isLoading: isLoadingContract, refetch: getContracts } = useQuery({
    queryKey: ['getContracts'],
    queryFn: () => ContractService.getLimited(100),
    refetchInterval: 10 * 600 * 1000,
    refetchOnWindowFocus: false,
  })

  const handleLogout = () => {
    signOut(auth).catch(error => console.log('Error logging out: ', error));
  };

  const spinnerContainerStyle: CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  };

  const spinnerStyle: CSSProperties = {
    border: '4px solid rgba(0, 0, 0, 0.1)',
    borderLeft: '4px solid #333',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    animation: 'spin 1s linear infinite',
  };

  if (isLoadingContract) {
    return (
      <div style={spinnerContainerStyle}>
        <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
        <div style={spinnerStyle}></div>
      </div>
    );
  }

  const logoutButtonStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: colors.brown_border,
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px',
    border: 'none',
    cursor: 'pointer',
    fontSize: '16px',
    color: 'white',
    fontWeight: '600',
    width: '100%',
  };

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      height: '100%',
      overflow: 'hidden' 
    }}>
      <PaymentScreen>
        <div style={{ flex: '1 1 auto', minHeight: 0, overflow: 'hidden' }}>
          <MasterDetail InitialContracts={contracts} />
        </div>

        <div style={{ flex: '0 0 auto', display: 'flex' }}>
          <button style={logoutButtonStyle} onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      </PaymentScreen>
    </div>
  );
}